<template>
  <Content title="客户这样评价我们" class="bg-white">
    <div id="commentCarousel" class="carousel slide" data-ride="carousel" data-interval="false">
      <div class="carousel-inner h-100">
        <div class="carousel-item comment-item active">
          <img src="/images/tks-note/tmc-tks-note1.png" class="w-100 letter-cover" alt="" />
        </div>
        <div class="carousel-item comment-item">
          <img src="/images/tks-note/tmc-tks-note2.png" class="w-100 letter-cover" alt="" />
        </div>
      </div>
      <a class="carousel-control-prev" href="#commentCarousel" role="button" data-slide="prev">
        <span class="carousel-preview-btn" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#commentCarousel" role="button" data-slide="next">
        <span class="carousel-next-btn" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </Content>
</template>
<script>
import Content from '@/shared/components/content.vue'
export default {
  name: 'DesktopComment',
  components: { Content },
  setup() {},
}
</script>

<style lang="scss" scoped>
.comment-item {
  padding-left: 128px;
  padding-right: 128px;
}
</style>
